/**
 * COAP Collector API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CoapMessage { 
    id?: number;
    insertTs?: string;
    parsingError?: string;
    errorResolved?: boolean;
    userData?: string;
    userDataLength?: number;
    payload?: Array<string>;
    scts?: string;
    idDevice?: number;
    idDeviceFound?: boolean;
    ignoreIdDeviceNotFound?: boolean;
    sentToQueue?: boolean;
    scheduleReprocess?: boolean;
    comId?: string;
    collectorMessageType?: CoapMessage.CollectorMessageTypeEnum;
    relativePositionRange?: string;
    messageCount?: string;
    gpsErrorCount?: string;
    rawData?: Array<string>;
    requestCode?: CoapMessage.RequestCodeEnum;
    sourceSocketAddress?: string;
    urlType?: CoapMessage.UrlTypeEnum;
    isConfirmable?: boolean;
    coapRequestFullBytes?: Array<string>;
    coapResponseFullBytes?: Array<string>;
    coapMessageId?: number;
    protocolType?: string;
    sensorType?: CoapMessage.SensorTypeEnum;
    dataFormat?: string;
    acknowledgeStatus?: CoapMessage.AcknowledgeStatusEnum;
    acknowledgeCommandNumber?: number;
}
export namespace CoapMessage {
    export const CollectorMessageTypeEnum = {
        MiscMessage: 'MISC_MESSAGE',
        Unknown: 'UNKNOWN',
        Invalid: 'INVALID',
        PositionMessage18Byte: 'POSITION_MESSAGE_18_BYTE',
        PositionMessage17Byte: 'POSITION_MESSAGE_17_BYTE',
        PositionMessage20Byte: 'POSITION_MESSAGE_20_BYTE',
        GpsPlusRemoteMessage140Byte: 'GPS_PLUS_REMOTE_MESSAGE_140_BYTE',
        VertexPlusRemoteMessage140Byte: 'VERTEX_PLUS_REMOTE_MESSAGE_140_BYTE',
        MortalityAlarm64Byte: 'MORTALITY_ALARM_64_BYTE',
        VirtualFenceAlarm64Byte: 'VIRTUAL_FENCE_ALARM_64_BYTE',
        ExternalSensorAlarm64Byte: 'EXTERNAL_SENSOR_ALARM_64_BYTE',
        ExtendedExternalSensorAlarm64Byte: 'EXTENDED_EXTERNAL_SENSOR_ALARM_64_BYTE',
        TrapAlarm64Byte: 'TRAP_ALARM_64_BYTE',
        ProximityStatus140Byte: 'PROXIMITY_STATUS_140_BYTE',
        ExtendedProximityStatus140Byte: 'EXTENDED_PROXIMITY_STATUS_140_BYTE',
        ExternalSensorStatus140Byte: 'EXTERNAL_SENSOR_STATUS_140_BYTE',
        ExtendedExternalSensorStatus140Byte: 'EXTENDED_EXTERNAL_SENSOR_STATUS_140_BYTE',
        DosimeterMessage140Byte: 'DOSIMETER_MESSAGE_140_BYTE',
        GlobalstarMortality: 'GLOBALSTAR_MORTALITY',
        GlobalstarShortPosition: 'GLOBALSTAR_SHORT_POSITION',
        GlobalstarLongPosition: 'GLOBALSTAR_LONG_POSITION',
        GlobalstarTrapTransmitter35: 'GLOBALSTAR_TRAP_TRANSMITTER_3_5',
        GlobalstarTrapTransmitter4: 'GLOBALSTAR_TRAP_TRANSMITTER_4',
        GlobalstarLegacyMessage: 'GLOBALSTAR_LEGACY_MESSAGE',
        CompactPositionMessageV1Solex: 'COMPACT_POSITION_MESSAGE_V1_SOLEX',
        CoapActivityMessage: 'COAP_ACTIVITY_MESSAGE',
        CoapConnectionMessage: 'COAP_CONNECTION_MESSAGE',
        PartOfConcatenatedSms: 'PART_OF_CONCATENATED_SMS',
        Gdx: 'GDX',
        CoapRemoteCommandAcknowledge: 'COAP_REMOTE_COMMAND_ACKNOWLEDGE',
        ShortHeaderCompactPositionV2: 'SHORT_HEADER_COMPACT_POSITION_V2',
        ShortHeaderMessage: 'SHORT_HEADER_MESSAGE',
        ShortHeaderRemoteCommand: 'SHORT_HEADER_REMOTE_COMMAND',
        ShortHeaderRemoteCommandAcknowledge: 'SHORT_HEADER_REMOTE_COMMAND_ACKNOWLEDGE',
        ShortHeaderConfigDataStatus: 'SHORT_HEADER_CONFIG_DATA_STATUS',
        HttpUpload: 'HTTP_UPLOAD',
        CompactPositionMessageV1Lite: 'COMPACT_POSITION_MESSAGE_V1_LITE'
    } as const;
    export type CollectorMessageTypeEnum = typeof CollectorMessageTypeEnum[keyof typeof CollectorMessageTypeEnum];
    export const RequestCodeEnum = {
        Get: 'GET',
        Post: 'POST',
        Put: 'PUT',
        Delete: 'DELETE',
        Fetch: 'FETCH',
        Patch: 'PATCH',
        Ipatch: 'IPATCH',
        Custom30: 'CUSTOM_30'
    } as const;
    export type RequestCodeEnum = typeof RequestCodeEnum[keyof typeof RequestCodeEnum];
    export const UrlTypeEnum = {
        DataV1: 'DATA_V1',
        AcknowledgeV1: 'ACKNOWLEDGE_V1',
        PaketMsgFormat: 'PAKET_MSG_FORMAT'
    } as const;
    export type UrlTypeEnum = typeof UrlTypeEnum[keyof typeof UrlTypeEnum];
    export const SensorTypeEnum = {
        Reserved: 'RESERVED',
        Gps: 'GPS',
        Mortality: 'MORTALITY',
        Activity: 'ACTIVITY',
        Proximty: 'PROXIMTY',
        Vit: 'VIT',
        Separation: 'SEPARATION',
        Mit: 'MIT',
        Csq: 'CSQ',
        ExternalSensorData: 'EXTERNAL_SENSOR_DATA',
        Connection: 'CONNECTION'
    } as const;
    export type SensorTypeEnum = typeof SensorTypeEnum[keyof typeof SensorTypeEnum];
    export const AcknowledgeStatusEnum = {
        PacketOk: 'PACKET_OK',
        WrongCoapHeader: 'WRONG_COAP_HEADER',
        WrongDataHeader: 'WRONG_DATA_HEADER',
        WrongIridiumHeader: 'WRONG_IRIDIUM_HEADER',
        ErrorInCommand: 'ERROR_IN_COMMAND',
        WrongRemoteCommand: 'WRONG_REMOTE_COMMAND'
    } as const;
    export type AcknowledgeStatusEnum = typeof AcknowledgeStatusEnum[keyof typeof AcknowledgeStatusEnum];
}


export type CollectorMessageTypeEnum = typeof CoapMessage.CollectorMessageTypeEnum[keyof typeof CoapMessage.CollectorMessageTypeEnum];
export type RequestCodeEnum = typeof CoapMessage.RequestCodeEnum[keyof typeof CoapMessage.RequestCodeEnum];
export type UrlTypeEnum = typeof CoapMessage.UrlTypeEnum[keyof typeof CoapMessage.UrlTypeEnum];
export type SensorTypeEnum = typeof CoapMessage.SensorTypeEnum[keyof typeof CoapMessage.SensorTypeEnum];
export type AcknowledgeStatusEnum = typeof CoapMessage.AcknowledgeStatusEnum[keyof typeof CoapMessage.AcknowledgeStatusEnum];
